/* ZX homepage sections (custom): add to cart, carousels, tabs, gallery, reveal */
(function () {
  if (window.__zxHome) return;
  window.__zxHome = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.documentElement.classList.add('zx-reveal-ready');

  /* ---------- Scroll reveal ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;

  function scan(scope) {
    (scope || document).querySelectorAll('[data-zx-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
    (scope || document).querySelectorAll('[data-zx-track]').forEach(bindTrack);
  }

  /* ---------- Carousel progress ---------- */
  function bindTrack(track) {
    if (track.__zxBound) return;
    track.__zxBound = true;
    var bar = document.querySelector('[data-zx-progress="' + track.id + '"]');
    function update() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = Math.max(ratio * 100, 10) + '%';
      bar.style.transform = 'translateX(' + (pos * (100 / Math.max(ratio, 0.1) - 100)) + '%)';
      bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var arrow = t.closest('[data-zx-scroll]');
    if (arrow) {
      var track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (track) {
        var dir = arrow.getAttribute('data-zx-scroll') === 'next' ? 1 : -1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        var atStart = track.scrollLeft <= 4;
        if (dir === 1 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir === -1 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      }
      return;
    }

    var tab = t.closest('[data-zx-tab]');
    if (tab) {
      var wrap = tab.closest('[data-zx-tabs]');
      wrap.querySelectorAll('[data-zx-tab]').forEach(function (x) {
        var on = x === tab;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      wrap.querySelectorAll('[data-zx-panel]').forEach(function (p) {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
        if (!p.hidden) scan(p);
      });
      return;
    }

    var thumb = t.closest('[data-zx-thumb]');
    if (thumb) {
      var main = document.getElementById(thumb.getAttribute('aria-controls'));
      if (main) {
        main.style.opacity = '0.3';
        main.src = thumb.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.onload = function () { main.style.opacity = '1'; };
      }
      thumb.parentElement.querySelectorAll('[data-zx-thumb]').forEach(function (x) {
        x.setAttribute('aria-current', x === thumb ? 'true' : 'false');
      });
      return;
    }

    var step = t.closest('[data-zx-step]');
    if (step) {
      var input = document.getElementById(step.getAttribute('aria-controls'));
      if (input) {
        var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-zx-step'), 10);
        input.value = Math.max(1, Math.min(99, v));
      }
      return;
    }

    var btn = t.closest('[data-zx-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      var idFrom = btn.getAttribute('data-zx-id-from');
      var qtyFrom = btn.getAttribute('data-zx-qty-from');
      var id = idFrom ? document.getElementById(idFrom).value : btn.getAttribute('data-zx-add');
      var qty = qtyFrom ? Math.max(1, parseInt(document.getElementById(qtyFrom).value, 10) || 1) : 1;
      addToCart(btn, id, qty, btn.hasAttribute('data-zx-buy-now'));
    }
  });

  /* ---------- Variant select (spotlight) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-zx-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var scope = sel.closest('[data-zx-product]');
    var now = scope.querySelector('[data-zx-price]');
    var was = scope.querySelector('[data-zx-compare]');
    if (now) {
      now.textContent = opt.getAttribute('data-price');
      now.classList.toggle('is-sale', !!opt.getAttribute('data-compare'));
    }
    if (was) {
      was.textContent = opt.getAttribute('data-compare') || '';
      was.hidden = !opt.getAttribute('data-compare');
    }
    var available = opt.getAttribute('data-available') === 'true';
    scope.querySelectorAll('[data-zx-add]').forEach(function (b) {
      b.disabled = !available;
      var l = b.querySelector('.zx-btn__label');
      if (l && !b.hasAttribute('data-zx-buy-now')) l.textContent = available ? (b.getAttribute('data-label') || 'Add to cart') : 'Sold out';
    });
    if (opt.getAttribute('data-image')) {
      var img = scope.querySelector('.zx-spot__media img');
      if (img) { img.src = opt.getAttribute('data-image'); img.removeAttribute('srcset'); }
    }
  });

  /* ---------- Add to cart (works with Horizon's cart drawer) ---------- */
  function setLabel(btn, text) {
    var l = btn.querySelector('.zx-btn__label');
    if (l) l.textContent = text;
  }

  async function addToCart(btn, id, qty, buyNow) {
    var original = btn.getAttribute('data-label') || 'Add to cart';
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      if (buyNow) {
        var r = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
        if (!r.ok) throw new Error('Could not add to cart');
        window.location.href = root + 'checkout';
        return;
      }

      var events = null;
      try { events = await import('@shopify/events'); } catch (err) { events = null; }
      var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) {
        return el.dataset.sectionId;
      }).filter(Boolean);

      var fd = new FormData();
      fd.set('id', id);
      fd.set('quantity', qty);
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));

      var deferred = null;
      if (events && events.CartLinesUpdateEvent) {
        deferred = events.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: qty }],
          promise: deferred.promise
        }));
      }

      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      }).then(function (x) { return x.json(); });

      if (res.status) {
        var msg = res.description || res.message || 'Could not add to cart';
        if (deferred) deferred.reject(new Error(msg));
        throw new Error(msg);
      }

      var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
      if (deferred) {
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'product-form-component',
            sourceId: 'zx-' + id,
            itemCount: qty,
            productId: btn.getAttribute('data-product-id'),
            sections: res.sections,
            didError: false
          }
        });
      }
      document.querySelectorAll('[data-zx-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setLabel(btn, 'Added ✓');
    } catch (err) {
      console.warn('[zx] add to cart failed', err);
      btn.classList.remove('is-loading');
      setLabel(btn, (err && err.message && err.message.length < 60) ? err.message : 'Try again');
    } finally {
      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading', 'is-added');
        setLabel(btn, original);
      }, 2200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
